// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_landing__Api from "../../../core/Api.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__LibraryArticle from "./LibraryArticle.js";
import * as Buhta_landing__LibraryHero from "../LibraryHero.js";
import * as Buhta_landing__LibrarySearch from "../LibrarySearch.js";
import * as Buhta_landing__LibrarySidebar from "../../../components/library/sidebar/LibrarySidebar.js";
import * as Buhta_landing__LoadingBar from "../../../core/LoadingBar.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as Caml_array from "melange.js/caml_array.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactHelmetAsync from "react-helmet-async";
import * as JsxRuntime from "react/jsx-runtime";

function LibraryArticlePage(Props) {
  let slug = Props.slug;
  let language = Props.language;
  const match = Buhta_landing__LoadingBar.LoadingBarContext.useLoadingBar(undefined);
  const dispatchLoadingBar = match[1];
  const match$1 = React.useState(function () {
    return "";
  });
  const setSearchField = match$1[1];
  const match$2 = React.useState(function () {
    return "";
  });
  const setQuery = match$2[1];
  const query = match$2[0];
  const currentRouteStr = Buhta_landing__Route.toAbsoluteString(Buhta_landing__Route.ofUrl(Buhta_landing__Route.useUrl(undefined)));
  const slugRE = /-(\d+)$/;
  const __x = slug.match(slugRE);
  const match_ = Belt__Belt_Option.getWithDefault(__x === null ? undefined : Caml_option.some(__x), [
    "",
    ""
  ]);
  const pageId = Belt__Belt_Option.getWithDefault(Caml_array.get(match_, 1), "");
  const match$3 = Buhta_landing__Content.Context.useContent(undefined);
  const dispatchContent = match$3[1];
  const content = match$3[0];
  const page = content.wikiPage;
  const tags = content.libraryTags;
  let currentTag;
  try {
    currentTag = Stdlib__List.find((function (tag) {
      const __x = Js__Js_json.decodeArray(page.tags);
      return tag.tag === Belt__Belt_Option.getWithDefault(Js__Js_json.decodeString(Caml_array.get(Belt__Belt_Option.getWithDefault(__x, []), 0)), "");
    }), tags);
  }
  catch (exn){
    currentTag = {
      tag: "",
      title: "",
      id: ""
    };
  }
  React.useEffect((function () {
    Curry._1(dispatchLoadingBar, /* Start */ 0);
    const __x = $$Promise.all({
      hd: Buhta_landing__Api.libraryTags(language),
      tl: {
        hd: Buhta_landing__Api.wikiPage(pageId),
        tl: {
          hd: Buhta_landing__Api.libraryFavorites(language),
          tl: /* [] */ 0
        }
      }
    });
    $$Promise.get(__x, (function (respList) {
      Stdlib__List.iter((function (res) {
        Buhta_landing__Api.handleResponse(res, dispatchContent, undefined);
      }), respList);
      Curry._1(dispatchLoadingBar, /* Complete */ 1);
    }));
  }), [
    pageId,
    language
  ]);
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs(ReactHelmetAsync.Helmet, {
        children: [
          JsxRuntime.jsx("title", {
            children: page.title
          }),
          JsxRuntime.jsx("meta", {
            content: page.description,
            name: "description"
          }),
          JsxRuntime.jsx("meta", {
            content: "article",
            property: "og:type"
          }),
          JsxRuntime.jsx("meta", {
            content: page.title,
            property: "og:title"
          }),
          JsxRuntime.jsx("meta", {
            content: page.description,
            property: "og:description"
          }),
          JsxRuntime.jsx("meta", {
            content: currentRouteStr,
            property: "og:url"
          }),
          JsxRuntime.jsx("meta", {
            content: page.imgUrl,
            property: "og:image"
          }),
          JsxRuntime.jsx("meta", {
            content: "summary_large_image",
            name: "twitter:card"
          }),
          JsxRuntime.jsx("meta", {
            content: page.title,
            name: "twitter:title"
          }),
          JsxRuntime.jsx("meta", {
            content: page.description,
            name: "twitter:description"
          }),
          JsxRuntime.jsx("meta", {
            content: currentRouteStr,
            name: "twitter:url"
          }),
          JsxRuntime.jsx("meta", {
            content: page.imgUrl,
            name: "twitter:image"
          })
        ]
      }),
      JsxRuntime.jsx(Buhta_landing__LibraryHero.make, {
        tags: tags,
        currentTag: currentTag,
        onSearch: (function (value) {
          Curry._1(setQuery, (function (param) {
            return value;
          }));
        }),
        searchField: match$1[0],
        onChangeSearchField: (function (value) {
          Curry._1(setSearchField, (function (param) {
            return value;
          }));
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          query.length !== 0 ? JsxRuntime.jsx(Buhta_landing__LibrarySearch.make, {
              query: query,
              clearQuery: (function (param) {
                Curry._1(setQuery, (function (param) {
                  return "";
                }));
                Curry._1(setSearchField, (function (param) {
                  return "";
                }));
              }),
              language: Buhta_models__Locale.fromString(language)
            }) : JsxRuntime.jsx(Buhta_landing__LibraryArticle.make, {
              page: page
            }),
          JsxRuntime.jsx(Buhta_landing__LibrarySidebar.make, {})
        ],
        className: "lg:w-304 lg:flex lg:mx-auto lg:justify-between mt-6 lg:mt-10 mb-10 lg:mb-20"
      })
    ]
  });
}

const make = LibraryArticlePage;

export {
  make,
}
/* Buhta_landing__Api Not a pure module */
